import { render, staticRenderFns } from "./SubmissionDCOSearch.vue?vue&type=template&id=ea877dae&scoped=true"
import script from "./SubmissionDCOSearch.vue?vue&type=script&lang=js"
export * from "./SubmissionDCOSearch.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDCOSearch.vue?vue&type=style&index=0&id=ea877dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea877dae",
  null
  
)

export default component.exports